import React, {useState, useCallback, useMemo, useEffect} from 'react';
import styles from './SuperCourses.module.scss';
import { Program, SelectOption } from '../../../types';
import Header from 'src/components/header/Header';
import Spinner from 'src/components/spinner/Spinner';
import Courses from 'src/components/dashboard-courses/Courses';
import FilterLayout from 'src/components/dashboard-courses/filter/FilterLayout';
import Footer from 'src/components/footer/Footer';
import Button from 'src/components/button/Button';
import { useHistory } from 'react-router-dom';
import CourseModal from './add-modal/CourseModal';
import { useGetAllProgramsLazyQuery } from '@api/graphql-codegen';

function filterCourses(search: string) {
  const s = search.toLowerCase();
  return (c: any) => {
    if (c.name.toLowerCase().includes(s)) return true;
    return false;
  };
}

function SuperCourses() {
  const [getAllPrograms, { data: coursesData, loading: coursesLoading}] = useGetAllProgramsLazyQuery({ fetchPolicy: 'network-only' })
  const history = useHistory();

  const [keyword, setKeyword] = useState('');
  const [country, setCountry] = useState<string>('');
  const [showModal, setShowModal] = useState(false)
  const [course, setCourse] = useState<Program>()

  const courseList = useMemo(() => coursesData?.programs || [], [coursesData?.programs]);

  useEffect(() => {
    getAllPrograms();
  },[getAllPrograms])

  const handleOpenNew = () => {
      history.push('/super/courses/new');
  };

  const handleChangeSearch = useCallback((v) => {
    setKeyword(v);
  }, []);

  const handleResetFilters = useCallback(() => {
    setCountry('');
    setKeyword('');
  }, []);

  const handleChangeCountry = useCallback((option: SelectOption) => {
    setCountry(option.value);
  },[])

  const handleCloseModal = () => {
    setShowModal(false)
  }

  const handleDuplicate = (newId: string, name: string) => {
    const newCourse = {
      ...course,
      id: newId,
      name
    }
    history.push({ pathname: '/super/courses/customize', state: { program: newCourse } })
  }

  const handleDuplicateCourse = (course: Program) => {
    setShowModal(true)
    setCourse(course)
  }

  const filtered = useMemo(() => {
    if (!courseList) return []
    let courses: any[] = courseList.filter(filterCourses(keyword));

    if (country) {
      courses = courses?.filter(course => course.country?.includes(country));
    }

    return courses
  }, [courseList, keyword, country]);

  return (
    <>
      <Header/>
      <div className={styles.page}>
        {coursesLoading ? <div className={styles.spinner}><Spinner/></div> : <>
          <div className={styles.actions}>
            <div className={styles.title}>Courses</div>
            <Button onClick={handleOpenNew} size={'small'} label={'Create Course'}/>
          </div>
          <FilterLayout keyword={keyword} country={country} handleChangeSearch={handleChangeSearch} handleChangeCountry={handleChangeCountry} handleResetFilters={handleResetFilters} />
          <Courses showEdit={true} courses={filtered} handleDuplicateCourse={handleDuplicateCourse}/>
        </>}
      </div>
      <Footer/>
      <CourseModal open={showModal} onClose={handleCloseModal} onCustome={handleDuplicate} course={course}/>
    </>
  );
}

export default SuperCourses;
